import React from 'react';
import { useTranslation } from 'react-i18next';
import { Row, Section, Toggle } from '../settingsPrimitives';
import { usePreferencesStore } from '../../store/preferencesStore';
import { isMacPlatform } from '../../utils/keyboard';

/**
 * Settings → Extensions → Terminal → "Keyboard" (Windows / Linux; command
 * palette PLAN §2.10, owner Q1 28.10.2026): "Send Ctrl+K to the shell"
 * (`terminalSendCtrlK`, default OFF — the palette opens from everywhere, the
 * terminal included). On: Ctrl+K inside a terminal is readline's / PSReadLine's
 * kill-to-end-of-line, and the palette stays one Ctrl+P away. VS Code ships the
 * same switch (`terminal.integrated.commandsToSkipShell`).
 *
 * macOS has no row: ⌘K is never a shell key there.
 */
export default function TerminalPaletteKeySetting() {
  const { t } = useTranslation();
  const sendCtrlK = usePreferencesStore((s) => s.terminalSendCtrlK === true);
  const update = usePreferencesStore((s) => s.updatePreference);

  if (isMacPlatform()) return null;
  return (
    <Section title={t('terminalExt.keyboardSection', 'Keyboard')}>
      <Row label={t('palette.terminal.sendCtrlK')} desc={t('palette.terminal.sendCtrlKDesc')}>
        <Toggle value={sendCtrlK} onChange={(v) => update('terminalSendCtrlK', v)} />
      </Row>
    </Section>
  );
}
